import { useTranslation } from '../contexts/localization/Localization'
import DimensionsScoresTooltip from './DimensionsScoresTooltip'
import Score from './Score'
import { useAppContext } from '../contexts/AppContext'
import { ViewMode } from '@playbooks/action-cards-utils'

export default function Footer() {
  const { data, settings } = useAppContext()
  const { text } = useTranslation()

  return !settings.hideScore && settings.viewMode !== ViewMode.FUNNEL ? (
    <div className="sticky z-20 bottom-0 w-full flex items-center bg-background px-4 py-5.5 mt-auto group/footer">
      <div data-testid="totalScore" className="ml-auto flex items-center gap-2">
        <div>{text('totalScore')}</div>

        <div className={`group-hover/footer:block hidden fixed right-2 bottom-10 text-left`}>
          <DimensionsScoresTooltip />
        </div>

        <Score value={data.score} />
      </div>
    </div>
  ) : null
}
